module.exports = __webpack_public_path__ + "static/showreel-c89b83d28af2596eb8e6d576e1ab102a.mp4";